<template>
  <div id="app" v-if="is_act_load">
    <HomePage></HomePage>
  </div>
  <div id="app_loading" v-else>

  </div>
</template>

<script>
  import HomePage from './container/HomePage.vue'
  import {ACT_NOT_INIT} from './constant/act_stat'
  import {PAGE_CREATE} from './constant/eventbus'

  export default {
    name: 'App',
    components: {
      HomePage
    },
    created(){
      console.log('app created')
      window.$bus.$emit(PAGE_CREATE);
      setTimeout(() => {
        if (window.Bulma) {
          window.Bulma.log('pv', {istc: "mem", ac: window.gact.source, uuid: window.$bus.user.uuid, uvip: window.$bus.user.uvip});
        }
        MgStat.send('pv', {}, {}) // 手动发送PV
      }, 1000);
    },
    computed:{
      is_act_load(){
        return window.$bus.act.act_stat !== ACT_NOT_INIT
      }
    }
  }
</script>

<style scoped lang="stylus">

  #app {
    width: 7.5rem;
    margin: 0 auto;
    min-height: 100vh;
    background white;
  }

</style>



// WEBPACK FOOTER //
// src/App.vue